<div *ngIf="isLoading$ | async" class="progress">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<router-outlet></router-outlet>
